<template>
    <div :class="$style.galleryCard" @click="enterGallery">
        <h2 :class="$style.text" v-html="$t('experience.onboarding.more_gallery_template')"></h2>
        <pt-button type="outline" color="whiteness">
            {{ $t('experience.onboarding.explore_gallery') }}
            <template #iconAfter>
                <pt-icon icon="icon-arrow-right"></pt-icon>
            </template>
        </pt-button>
        <!-- <img :class="$style.imgLeft" src="/images/pt-pic-Templatesleft.png" alt="" />
        <img :class="$style.imgRight" src="/images/pt-pic-Templatesright.png" alt="" /> -->
    </div>
</template>

<script lang="ts">
export default {
    name: 'TemplateGalleryCard'
};
</script>

<script lang="ts" setup>
import { useRouter } from 'vue-router';
import analyticsService from '@assets/services/analytics.service';
// interface

// props

// emits

// state
const router = useRouter();
// computed

// watch

// onMounted

// onUnmounted

// function
function enterGallery() {
    // router.push({
    //     name: 'Gallery'
    // });
    const openUrl = `${location.origin}${import.meta.env.VITE_BASE_URL}gallery`;
    window.open(openUrl);
    analyticsService.usePTX('explore_gallery_click').track();
}
</script>

<style lang="scss" module>
@import '@style/import.scss';
.galleryCard {
    width: 100%;
    height: 100%;
    background: url('/images/recommd-curve-2.svg') no-repeat center center,linear-gradient(90deg,#253858,#344563,#253858);
    padding: 48px 24px;
    border-radius: 3px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
        box-shadow: 0 4px 4px rgb(9 30 66 / 30%);
    }
    .text {
        font-size: 28px;
        max-width: 200px;
        color: $pt-white;
        margin-bottom: 30px;
    }
    .imgLeft {
        position: absolute;
        left: -60px;
        bottom: -60px;
    }
    .imgRight {
        position: absolute;
        right: -64px;
        bottom: 0;
    }
}
</style>
